import _toConsumableArray from "/home/runner/work/alignerbase-web/alignerbase-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/runner/work/alignerbase-web/alignerbase-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/alignerbase-web/alignerbase-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/alignerbase-web/alignerbase-web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import _regeneratorRuntime from "/home/runner/work/alignerbase-web/alignerbase-web/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import e, { createContext as t, useState as r, useCallback as o, useMemo as l, useContext as n, useRef as a, useEffect as c, useLayoutEffect as i } from "react";
import s from "classnames";
import { arrow as u, computePosition as d, offset as p, flip as v, shift as m } from "@floating-ui/dom";
var f = function f(e, t, r) {
    var o = null;
    return function () {
      var _this = this;
      for (var _len = arguments.length, l = new Array(_len), _key = 0; _key < _len; _key++) {
        l[_key] = arguments[_key];
      }
      var n = function n() {
        o = null, r || e.apply(_this, l);
      };
      r && !o && (e.apply(this, l), o = setTimeout(n, t)), r || (o && clearTimeout(o), o = setTimeout(n, t));
    };
  },
  h = {
    anchorRefs: new Set(),
    activeAnchor: {
      current: null
    },
    attach: function attach() {},
    detach: function detach() {},
    setActiveAnchor: function setActiveAnchor() {}
  },
  y = t({
    getTooltipData: function getTooltipData() {
      return h;
    }
  }),
  w = function w(_ref) {
    var t = _ref.children;
    var _r = r({
        DEFAULT_TOOLTIP_ID: new Set()
      }),
      _r2 = _slicedToArray(_r, 2),
      n = _r2[0],
      a = _r2[1],
      _r3 = r({
        DEFAULT_TOOLTIP_ID: {
          current: null
        }
      }),
      _r4 = _slicedToArray(_r3, 2),
      c = _r4[0],
      i = _r4[1],
      s = function s(e) {
        for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          t[_key2 - 1] = arguments[_key2];
        }
        a(function (r) {
          var o;
          var l = null !== (o = r[e]) && void 0 !== o ? o : new Set();
          return t.forEach(function (e) {
            return l.add(e);
          }), _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, e, new Set(l)));
        });
      },
      u = function u(e) {
        for (var _len3 = arguments.length, t = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          t[_key3 - 1] = arguments[_key3];
        }
        a(function (r) {
          var o = r[e];
          return o ? (t.forEach(function (e) {
            return o.delete(e);
          }), _objectSpread({}, r)) : r;
        });
      },
      d = o(function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "DEFAULT_TOOLTIP_ID";
        var t, r;
        return {
          anchorRefs: null !== (t = n[e]) && void 0 !== t ? t : new Set(),
          activeAnchor: null !== (r = c[e]) && void 0 !== r ? r : {
            current: null
          },
          attach: function attach() {
            for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              t[_key4] = arguments[_key4];
            }
            return s.apply(void 0, [e].concat(t));
          },
          detach: function detach() {
            for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              t[_key5] = arguments[_key5];
            }
            return u.apply(void 0, [e].concat(t));
          },
          setActiveAnchor: function setActiveAnchor(t) {
            return function (e, t) {
              i(function (r) {
                var o;
                return (null === (o = r[e]) || void 0 === o ? void 0 : o.current) === t.current ? r : _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, e, t));
              });
            }(e, t);
          }
        };
      }, [n, c, s, u]),
      p = l(function () {
        return {
          getTooltipData: d
        };
      }, [d]);
    return e.createElement(y.Provider, {
      value: p
    }, t);
  };
function A() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "DEFAULT_TOOLTIP_ID";
  return n(y).getTooltipData(e);
}
var S = function S(_ref2) {
    var t = _ref2.tooltipId,
      r = _ref2.children,
      o = _ref2.className,
      l = _ref2.place,
      n = _ref2.content,
      i = _ref2.html,
      u = _ref2.variant,
      d = _ref2.offset,
      p = _ref2.wrapper,
      v = _ref2.events,
      m = _ref2.positionStrategy,
      f = _ref2.delayShow,
      h = _ref2.delayHide;
    var _A = A(t),
      y = _A.attach,
      w = _A.detach,
      S = a(null);
    return c(function () {
      return y(S), function () {
        w(S);
      };
    }, []), e.createElement("span", {
      ref: S,
      className: s("react-tooltip-wrapper", o),
      "data-tooltip-place": l,
      "data-tooltip-content": n,
      "data-tooltip-html": i,
      "data-tooltip-variant": u,
      "data-tooltip-offset": d,
      "data-tooltip-wrapper": p,
      "data-tooltip-events": v,
      "data-tooltip-position-strategy": m,
      "data-tooltip-delay-show": f,
      "data-tooltip-delay-hide": h
    }, r);
  },
  _ = "undefined" != typeof window ? i : c,
  b = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
      var _ref3$elementReferenc, e, _ref3$tooltipReferenc, t, _ref3$tooltipArrowRef, r, _ref3$place, o, _ref3$offset, l, _ref3$strategy, n, _ref3$middlewares, a, c;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref3$elementReferenc = _ref3.elementReference, e = _ref3$elementReferenc === void 0 ? null : _ref3$elementReferenc, _ref3$tooltipReferenc = _ref3.tooltipReference, t = _ref3$tooltipReferenc === void 0 ? null : _ref3$tooltipReferenc, _ref3$tooltipArrowRef = _ref3.tooltipArrowReference, r = _ref3$tooltipArrowRef === void 0 ? null : _ref3$tooltipArrowRef, _ref3$place = _ref3.place, o = _ref3$place === void 0 ? "top" : _ref3$place, _ref3$offset = _ref3.offset, l = _ref3$offset === void 0 ? 10 : _ref3$offset, _ref3$strategy = _ref3.strategy, n = _ref3$strategy === void 0 ? "absolute" : _ref3$strategy, _ref3$middlewares = _ref3.middlewares, a = _ref3$middlewares === void 0 ? [p(Number(l)), v(), m({
              padding: 5
            })] : _ref3$middlewares;
            if (e) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", {
              tooltipStyles: {},
              tooltipArrowStyles: {},
              place: o
            });
          case 3:
            if (!(null === t)) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", {
              tooltipStyles: {},
              tooltipArrowStyles: {},
              place: o
            });
          case 5:
            c = a;
            return _context.abrupt("return", r ? (c.push(u({
              element: r,
              padding: 5
            })), d(e, t, {
              placement: o,
              strategy: n,
              middleware: c
            }).then(function (_ref5) {
              var e = _ref5.x,
                t = _ref5.y,
                r = _ref5.placement,
                o = _ref5.middlewareData;
              var l, n;
              var a = {
                  left: "".concat(e, "px"),
                  top: "".concat(t, "px")
                },
                _ref6 = null !== (l = o.arrow) && void 0 !== l ? l : {
                  x: 0,
                  y: 0
                },
                c = _ref6.x,
                i = _ref6.y;
              return {
                tooltipStyles: a,
                tooltipArrowStyles: _defineProperty({
                  left: null != c ? "".concat(c, "px") : "",
                  top: null != i ? "".concat(i, "px") : "",
                  right: "",
                  bottom: ""
                }, null !== (n = {
                  top: "bottom",
                  right: "left",
                  bottom: "top",
                  left: "right"
                }[r.split("-")[0]]) && void 0 !== n ? n : "bottom", "-4px"),
                place: r
              };
            })) : d(e, t, {
              placement: "bottom",
              strategy: n,
              middleware: c
            }).then(function (_ref7) {
              var e = _ref7.x,
                t = _ref7.y,
                r = _ref7.placement;
              return {
                tooltipStyles: {
                  left: "".concat(e, "px"),
                  top: "".concat(t, "px")
                },
                tooltipArrowStyles: {},
                place: r
              };
            }));
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function b(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
var g = {
  tooltip: "styles-module_tooltip__mnnfp",
  fixed: "styles-module_fixed__7ciUi",
  arrow: "styles-module_arrow__K0L3T",
  noArrow: "styles-module_noArrow__T8y2L",
  clickable: "styles-module_clickable__Bv9o7",
  show: "styles-module_show__2NboJ",
  dark: "styles-module_dark__xNqje",
  light: "styles-module_light__Z6W-X",
  success: "styles-module_success__A2AKt",
  warning: "styles-module_warning__SCK0X",
  error: "styles-module_error__JvumD",
  info: "styles-module_info__BWdHW"
};
var E = function E(_ref8) {
    var _s;
    var t = _ref8.id,
      o = _ref8.className,
      l = _ref8.classNameArrow,
      _ref8$variant = _ref8.variant,
      n = _ref8$variant === void 0 ? "dark" : _ref8$variant,
      i = _ref8.anchorId,
      u = _ref8.anchorSelect,
      _ref8$place = _ref8.place,
      d = _ref8$place === void 0 ? "top" : _ref8$place,
      _ref8$offset = _ref8.offset,
      p = _ref8$offset === void 0 ? 10 : _ref8$offset,
      _ref8$events = _ref8.events,
      v = _ref8$events === void 0 ? ["hover"] : _ref8$events,
      _ref8$openOnClick = _ref8.openOnClick,
      m = _ref8$openOnClick === void 0 ? !1 : _ref8$openOnClick,
      _ref8$positionStrateg = _ref8.positionStrategy,
      h = _ref8$positionStrateg === void 0 ? "absolute" : _ref8$positionStrateg,
      y = _ref8.middlewares,
      w = _ref8.wrapper,
      _ref8$delayShow = _ref8.delayShow,
      S = _ref8$delayShow === void 0 ? 0 : _ref8$delayShow,
      _ref8$delayHide = _ref8.delayHide,
      E = _ref8$delayHide === void 0 ? 0 : _ref8$delayHide,
      _ref8$float = _ref8.float,
      T = _ref8$float === void 0 ? !1 : _ref8$float,
      _ref8$noArrow = _ref8.noArrow,
      O = _ref8$noArrow === void 0 ? !1 : _ref8$noArrow,
      _ref8$clickable = _ref8.clickable,
      k = _ref8$clickable === void 0 ? !1 : _ref8$clickable,
      _ref8$closeOnEsc = _ref8.closeOnEsc,
      L = _ref8$closeOnEsc === void 0 ? !1 : _ref8$closeOnEsc,
      N = _ref8.style,
      x = _ref8.position,
      R = _ref8.afterShow,
      I = _ref8.afterHide,
      $ = _ref8.content,
      D = _ref8.contentWrapperRef,
      H = _ref8.isOpen,
      j = _ref8.setIsOpen,
      q = _ref8.activeAnchor,
      C = _ref8.setActiveAnchor;
    var W = a(null),
      F = a(null),
      P = a(null),
      U = a(null),
      _r5 = r(d),
      _r6 = _slicedToArray(_r5, 2),
      M = _r6[0],
      B = _r6[1],
      _r7 = r({}),
      _r8 = _slicedToArray(_r7, 2),
      K = _r8[0],
      X = _r8[1],
      _r9 = r({}),
      _r10 = _slicedToArray(_r9, 2),
      z = _r10[0],
      J = _r10[1],
      _r11 = r(!1),
      _r12 = _slicedToArray(_r11, 2),
      Y = _r12[0],
      Z = _r12[1],
      _r13 = r(!1),
      _r14 = _slicedToArray(_r13, 2),
      G = _r14[0],
      Q = _r14[1],
      V = a(!1),
      ee = a(null),
      _A2 = A(t),
      te = _A2.anchorRefs,
      re = _A2.setActiveAnchor,
      oe = a(!1),
      _r15 = r([]),
      _r16 = _slicedToArray(_r15, 2),
      le = _r16[0],
      ne = _r16[1],
      ae = a(!1),
      ce = m || v.includes("click");
    _(function () {
      return ae.current = !0, function () {
        ae.current = !1;
      };
    }, []), c(function () {
      if (!Y) {
        var _e = setTimeout(function () {
          Q(!1);
        }, 150);
        return function () {
          clearTimeout(_e);
        };
      }
      return function () {
        return null;
      };
    }, [Y]);
    var ie = function ie(e) {
      ae.current && (e && Q(!0), setTimeout(function () {
        ae.current && (null == j || j(e), void 0 === H && Z(e));
      }, 10));
    };
    c(function () {
      if (void 0 === H) return function () {
        return null;
      };
      H && Q(!0);
      var e = setTimeout(function () {
        Z(H);
      }, 10);
      return function () {
        clearTimeout(e);
      };
    }, [H]), c(function () {
      Y !== V.current && (V.current = Y, Y ? null == R || R() : null == I || I());
    }, [Y]);
    var se = function se() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : E;
        U.current && clearTimeout(U.current), U.current = setTimeout(function () {
          oe.current || ie(!1);
        }, e);
      },
      ue = function ue(e) {
        var t;
        if (!e) return;
        var r = null !== (t = e.currentTarget) && void 0 !== t ? t : e.target;
        if (!(null == r ? void 0 : r.isConnected)) return C(null), void re({
          current: null
        });
        S ? (P.current && clearTimeout(P.current), P.current = setTimeout(function () {
          ie(!0);
        }, S)) : ie(!0), C(r), re({
          current: r
        }), U.current && clearTimeout(U.current);
      },
      de = function de() {
        k ? se(E || 100) : E ? se() : ie(!1), P.current && clearTimeout(P.current);
      },
      pe = function pe(_ref9) {
        var e = _ref9.x,
          t = _ref9.y;
        b({
          place: d,
          offset: p,
          elementReference: {
            getBoundingClientRect: function getBoundingClientRect() {
              return {
                x: e,
                y: t,
                width: 0,
                height: 0,
                top: t,
                left: e,
                right: e,
                bottom: t
              };
            }
          },
          tooltipReference: W.current,
          tooltipArrowReference: F.current,
          strategy: h,
          middlewares: y
        }).then(function (e) {
          Object.keys(e.tooltipStyles).length && X(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && J(e.tooltipArrowStyles), B(e.place);
        });
      },
      ve = function ve(e) {
        if (!e) return;
        var t = e,
          r = {
            x: t.clientX,
            y: t.clientY
          };
        pe(r), ee.current = r;
      },
      me = function me(e) {
        ue(e), E && se();
      },
      fe = function fe(e) {
        var t;
        [document.querySelector("[id='".concat(i, "']"))].concat(_toConsumableArray(le)).some(function (t) {
          return null == t ? void 0 : t.contains(e.target);
        }) || (null === (t = W.current) || void 0 === t ? void 0 : t.contains(e.target)) || ie(!1);
      },
      he = function he(e) {
        "Escape" === e.key && ie(!1);
      },
      ye = f(ue, 50, !0),
      we = f(de, 50, !0);
    c(function () {
      var e, t;
      var r = new Set(te);
      le.forEach(function (e) {
        r.add({
          current: e
        });
      });
      var o = document.querySelector("[id='".concat(i, "']"));
      o && r.add({
        current: o
      }), L && window.addEventListener("keydown", he);
      var l = [];
      ce ? (window.addEventListener("click", fe), l.push({
        event: "click",
        listener: me
      })) : (l.push({
        event: "mouseenter",
        listener: ye
      }, {
        event: "mouseleave",
        listener: we
      }, {
        event: "focus",
        listener: ye
      }, {
        event: "blur",
        listener: we
      }), T && l.push({
        event: "mousemove",
        listener: ve
      }));
      var n = function n() {
          oe.current = !0;
        },
        a = function a() {
          oe.current = !1, de();
        };
      return k && !ce && (null === (e = W.current) || void 0 === e || e.addEventListener("mouseenter", n), null === (t = W.current) || void 0 === t || t.addEventListener("mouseleave", a)), l.forEach(function (_ref10) {
        var e = _ref10.event,
          t = _ref10.listener;
        r.forEach(function (r) {
          var o;
          null === (o = r.current) || void 0 === o || o.addEventListener(e, t);
        });
      }), function () {
        var e, t;
        ce && window.removeEventListener("click", fe), L && window.removeEventListener("keydown", he), k && !ce && (null === (e = W.current) || void 0 === e || e.removeEventListener("mouseenter", n), null === (t = W.current) || void 0 === t || t.removeEventListener("mouseleave", a)), l.forEach(function (_ref11) {
          var e = _ref11.event,
            t = _ref11.listener;
          r.forEach(function (r) {
            var o;
            null === (o = r.current) || void 0 === o || o.removeEventListener(e, t);
          });
        });
      };
    }, [G, te, le, L, v]), c(function () {
      var e = null != u ? u : "";
      !e && t && (e = "[data-tooltip-id='".concat(t, "']"));
      var r = new MutationObserver(function (r) {
        var o = [];
        r.forEach(function (r) {
          if ("attributes" === r.type && "data-tooltip-id" === r.attributeName) {
            r.target.getAttribute("data-tooltip-id") === t && o.push(r.target);
          }
          if ("childList" === r.type && (q && _toConsumableArray(r.removedNodes).some(function (e) {
            var t;
            return !!(null === (t = null == e ? void 0 : e.contains) || void 0 === t ? void 0 : t.call(e, q)) && (Q(!1), ie(!1), C(null), !0);
          }), e)) try {
            var _t = _toConsumableArray(r.addedNodes).filter(function (e) {
              return 1 === e.nodeType;
            });
            o.push.apply(o, _toConsumableArray(_t.filter(function (t) {
              return t.matches(e);
            }))), o.push.apply(o, _toConsumableArray(_t.flatMap(function (t) {
              return _toConsumableArray(t.querySelectorAll(e));
            })));
          } catch (e) {}
        }), o.length && ne(function (e) {
          return [].concat(_toConsumableArray(e), o);
        });
      });
      return r.observe(document.body, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["data-tooltip-id"]
      }), function () {
        r.disconnect();
      };
    }, [t, u, q]);
    var Ae = function Ae() {
      x ? pe(x) : T ? ee.current && pe(ee.current) : b({
        place: d,
        offset: p,
        elementReference: q,
        tooltipReference: W.current,
        tooltipArrowReference: F.current,
        strategy: h,
        middlewares: y
      }).then(function (e) {
        ae.current && (Object.keys(e.tooltipStyles).length && X(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && J(e.tooltipArrowStyles), B(e.place));
      });
    };
    c(function () {
      Ae();
    }, [Y, q, $, N, d, p, h, x]), c(function () {
      if (!(null == D ? void 0 : D.current)) return function () {
        return null;
      };
      var e = new ResizeObserver(function () {
        Ae();
      });
      return e.observe(D.current), function () {
        e.disconnect();
      };
    }, [$, null == D ? void 0 : D.current]), c(function () {
      var e;
      var t = document.querySelector("[id='".concat(i, "']")),
        r = [].concat(_toConsumableArray(le), [t]);
      q && r.includes(q) || C(null !== (e = le[0]) && void 0 !== e ? e : t);
    }, [i, le, q]), c(function () {
      return function () {
        P.current && clearTimeout(P.current), U.current && clearTimeout(U.current);
      };
    }, []), c(function () {
      var e = u;
      if (!e && t && (e = "[data-tooltip-id='".concat(t, "']")), e) try {
        var _t2 = Array.from(document.querySelectorAll(e));
        ne(_t2);
      } catch (e) {
        ne([]);
      }
    }, [t, u]);
    var Se = $ && Y && Object.keys(K).length > 0;
    return G ? e.createElement(w, {
      id: t,
      role: "tooltip",
      className: s("react-tooltip", g.tooltip, g[n], o, "react-tooltip__place-".concat(M), (_s = {}, _defineProperty(_s, g.show, Se), _defineProperty(_s, g.fixed, "fixed" === h), _defineProperty(_s, g.clickable, k), _s)),
      style: _objectSpread(_objectSpread({}, N), K),
      ref: W
    }, $, e.createElement(w, {
      className: s("react-tooltip-arrow", g.arrow, l, _defineProperty({}, g.noArrow, O)),
      style: z,
      ref: F
    })) : null;
  },
  T = function T(_ref12) {
    var t = _ref12.content;
    return e.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: t
      }
    });
  },
  O = function O(_ref13) {
    var t = _ref13.id,
      o = _ref13.anchorId,
      l = _ref13.anchorSelect,
      n = _ref13.content,
      i = _ref13.html,
      s = _ref13.render,
      u = _ref13.className,
      d = _ref13.classNameArrow,
      _ref13$variant = _ref13.variant,
      p = _ref13$variant === void 0 ? "dark" : _ref13$variant,
      _ref13$place = _ref13.place,
      v = _ref13$place === void 0 ? "top" : _ref13$place,
      _ref13$offset = _ref13.offset,
      m = _ref13$offset === void 0 ? 10 : _ref13$offset,
      _ref13$wrapper = _ref13.wrapper,
      f = _ref13$wrapper === void 0 ? "div" : _ref13$wrapper,
      _ref13$children = _ref13.children,
      h = _ref13$children === void 0 ? null : _ref13$children,
      _ref13$events = _ref13.events,
      y = _ref13$events === void 0 ? ["hover"] : _ref13$events,
      _ref13$openOnClick = _ref13.openOnClick,
      w = _ref13$openOnClick === void 0 ? !1 : _ref13$openOnClick,
      _ref13$positionStrate = _ref13.positionStrategy,
      S = _ref13$positionStrate === void 0 ? "absolute" : _ref13$positionStrate,
      _ = _ref13.middlewares,
      _ref13$delayShow = _ref13.delayShow,
      b = _ref13$delayShow === void 0 ? 0 : _ref13$delayShow,
      _ref13$delayHide = _ref13.delayHide,
      g = _ref13$delayHide === void 0 ? 0 : _ref13$delayHide,
      _ref13$float = _ref13.float,
      O = _ref13$float === void 0 ? !1 : _ref13$float,
      _ref13$noArrow = _ref13.noArrow,
      k = _ref13$noArrow === void 0 ? !1 : _ref13$noArrow,
      _ref13$clickable = _ref13.clickable,
      L = _ref13$clickable === void 0 ? !1 : _ref13$clickable,
      _ref13$closeOnEsc = _ref13.closeOnEsc,
      N = _ref13$closeOnEsc === void 0 ? !1 : _ref13$closeOnEsc,
      x = _ref13.style,
      R = _ref13.position,
      I = _ref13.isOpen,
      $ = _ref13.setIsOpen,
      D = _ref13.afterShow,
      H = _ref13.afterHide;
    var _r17 = r(n),
      _r18 = _slicedToArray(_r17, 2),
      j = _r18[0],
      q = _r18[1],
      _r19 = r(i),
      _r20 = _slicedToArray(_r19, 2),
      C = _r20[0],
      W = _r20[1],
      _r21 = r(v),
      _r22 = _slicedToArray(_r21, 2),
      F = _r22[0],
      P = _r22[1],
      _r23 = r(p),
      _r24 = _slicedToArray(_r23, 2),
      U = _r24[0],
      M = _r24[1],
      _r25 = r(m),
      _r26 = _slicedToArray(_r25, 2),
      B = _r26[0],
      K = _r26[1],
      _r27 = r(b),
      _r28 = _slicedToArray(_r27, 2),
      X = _r28[0],
      z = _r28[1],
      _r29 = r(g),
      _r30 = _slicedToArray(_r29, 2),
      J = _r30[0],
      Y = _r30[1],
      _r31 = r(O),
      _r32 = _slicedToArray(_r31, 2),
      Z = _r32[0],
      G = _r32[1],
      _r33 = r(f),
      _r34 = _slicedToArray(_r33, 2),
      Q = _r34[0],
      V = _r34[1],
      _r35 = r(y),
      _r36 = _slicedToArray(_r35, 2),
      ee = _r36[0],
      te = _r36[1],
      _r37 = r(S),
      _r38 = _slicedToArray(_r37, 2),
      re = _r38[0],
      oe = _r38[1],
      _r39 = r(null),
      _r40 = _slicedToArray(_r39, 2),
      le = _r40[0],
      ne = _r40[1],
      _A3 = A(t),
      ae = _A3.anchorRefs,
      ce = _A3.activeAnchor,
      ie = function ie(e) {
        return null == e ? void 0 : e.getAttributeNames().reduce(function (t, r) {
          var o;
          if (r.startsWith("data-tooltip-")) {
            t[r.replace(/^data-tooltip-/, "")] = null !== (o = null == e ? void 0 : e.getAttribute(r)) && void 0 !== o ? o : null;
          }
          return t;
        }, {});
      },
      se = function se(e) {
        var t = {
          place: function place(e) {
            var t;
            P(null !== (t = e) && void 0 !== t ? t : v);
          },
          content: function content(e) {
            q(null != e ? e : n);
          },
          html: function html(e) {
            W(null != e ? e : i);
          },
          variant: function variant(e) {
            var t;
            M(null !== (t = e) && void 0 !== t ? t : p);
          },
          offset: function offset(e) {
            K(null === e ? m : Number(e));
          },
          wrapper: function wrapper(e) {
            var t;
            V(null !== (t = e) && void 0 !== t ? t : f);
          },
          events: function events(e) {
            var t = null == e ? void 0 : e.split(" ");
            te(null != t ? t : y);
          },
          "position-strategy": function positionStrategy(e) {
            var t;
            oe(null !== (t = e) && void 0 !== t ? t : S);
          },
          "delay-show": function delayShow(e) {
            z(null === e ? b : Number(e));
          },
          "delay-hide": function delayHide(e) {
            Y(null === e ? g : Number(e));
          },
          float: function float(e) {
            G(null === e ? O : "true" === e);
          }
        };
        Object.values(t).forEach(function (e) {
          return e(null);
        }), Object.entries(e).forEach(function (_ref14) {
          var _ref15 = _slicedToArray(_ref14, 2),
            e = _ref15[0],
            r = _ref15[1];
          var o;
          null === (o = t[e]) || void 0 === o || o.call(t, r);
        });
      };
    c(function () {
      q(n);
    }, [n]), c(function () {
      W(i);
    }, [i]), c(function () {
      P(v);
    }, [v]), c(function () {
      var e;
      var r = new Set(ae);
      var n = l;
      if (!n && t && (n = "[data-tooltip-id='".concat(t, "']")), n) try {
        document.querySelectorAll(n).forEach(function (e) {
          r.add({
            current: e
          });
        });
      } catch (e) {
        console.warn("[react-tooltip] \"".concat(l, "\" is not a valid CSS selector"));
      }
      var a = document.querySelector("[id='".concat(o, "']"));
      if (a && r.add({
        current: a
      }), !r.size) return function () {
        return null;
      };
      var c = null !== (e = null != le ? le : a) && void 0 !== e ? e : ce.current,
        i = new MutationObserver(function (e) {
          e.forEach(function (e) {
            var t;
            if (!c || "attributes" !== e.type || !(null === (t = e.attributeName) || void 0 === t ? void 0 : t.startsWith("data-tooltip-"))) return;
            var r = ie(c);
            se(r);
          });
        }),
        s = {
          attributes: !0,
          childList: !1,
          subtree: !1
        };
      if (c) {
        var _e2 = ie(c);
        se(_e2), i.observe(c, s);
      }
      return function () {
        i.disconnect();
      };
    }, [ae, ce, le, o, l]);
    var ue = h;
    var de = a(null);
    if (s) {
      var _t3 = s({
        content: null != j ? j : null,
        activeAnchor: le
      });
      ue = _t3 ? e.createElement("div", {
        ref: de,
        className: "react-tooltip-content-wrapper"
      }, _t3) : null;
    } else j && (ue = j);
    C && (ue = e.createElement(T, {
      content: C
    }));
    var pe = {
      id: t,
      anchorId: o,
      anchorSelect: l,
      className: u,
      classNameArrow: d,
      content: ue,
      contentWrapperRef: de,
      place: F,
      variant: U,
      offset: B,
      wrapper: Q,
      events: ee,
      openOnClick: w,
      positionStrategy: re,
      middlewares: _,
      delayShow: X,
      delayHide: J,
      float: Z,
      noArrow: k,
      clickable: L,
      closeOnEsc: N,
      style: x,
      position: R,
      isOpen: I,
      setIsOpen: $,
      afterShow: D,
      afterHide: H,
      activeAnchor: le,
      setActiveAnchor: function setActiveAnchor(e) {
        return ne(e);
      }
    };
    return e.createElement(E, _objectSpread({}, pe));
  };
export { O as Tooltip, w as TooltipProvider, S as TooltipWrapper };